import React from 'react'
import styled from '@emotion/styled'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src/types'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {SelectedElement} from '../HotelLocationMap/TrackLocationClick'

type PropsTypes = {
  hotel: ContentHotel
  variant?: 'default' | 'small'
}

const LocationDetailsWrapper = styled.div<{$small?: boolean}>`
  text-align: left;
  ${({$small}) =>
    $small ? cssTheme.typography.bodyS : cssTheme.typography.bodyM}
`

const LocationSummaryLoader = () => <SkeletonLoader width={120} marginTop={0} />

export const LocationAddress = ({hotel, variant = 'default'}: PropsTypes) => {
  return (
    <div data-id={SelectedElement.CompleteAddress}>
      {hotel ? (
        <LocationDetailsWrapper $small={variant === 'small'}>
          {hotel.displayAddress}
        </LocationDetailsWrapper>
      ) : (
        <LocationSummaryLoader />
      )}
    </div>
  )
}
